import { render } from "./SideBarLeftNew.vue?vue&type=template&id=2a947b2e&scoped=true"
import script from "./SideBarLeftNew.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarLeftNew.vue?vue&type=script&setup=true&lang=js"

import "./SideBarLeftNew.vue?vue&type=style&index=0&id=2a947b2e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a947b2e"],['__file',"src/components/app/sidebar/SideBarLeftNew.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a947b2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a947b2e', __exports__)) {
    api.reload('2a947b2e', __exports__)
  }
  
  module.hot.accept("./SideBarLeftNew.vue?vue&type=template&id=2a947b2e&scoped=true", () => {
    api.rerender('2a947b2e', render)
  })

}


export default __exports__